import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title \"Index\"}}\n{{outlet}}",{ moduleName: "editor/restricted/index/template.hbs" })